'use strict';

define('lib/transforms/series.byCategory',['../page-cache'], function (PageCache) {
  // This function simply waits for the original series data to be set in the
  // session and transform it in various ways.
  var __defaultCategorySortOrder = ['cars-n-minivans', 'trucks', 'crossovers-n-suvs', 'hybrids-n-evs'];

  function sortByName(a, b) {
    return a.series_name < b.series_name ? -1 : a.series_name > b.series_name ? 1 : 0;
  }

  function categorizeSeries(allSeries, needsSort) {
    var byCategory = {};
    var sorted = {};

    if (!!needsSort) {
      allSeries.sort(sortByName);
    }

    allSeries.forEach(function (series) {
      series.categories.forEach(function (cat) {
        if (!byCategory[cat.code]) {
          byCategory[cat.code] = {
            code: cat.code,
            name: cat.name,
            series: [],
          };
        }

        // All gets every series
        byCategory[cat.code].series.push(series);
      });
    });

    // Sort the categories on the object
    __defaultCategorySortOrder.forEach(function (catId) {
      if (byCategory[catId]) {
        sorted[catId] = byCategory[catId];
        delete byCategory[catId];
      }
    });

    // Catch anything we miss
    Object.keys(byCategory).forEach(function (catId) {
      sorted[catId] = byCategory[catId];
    });

    return sorted;
  }

  PageCache.await('series.raw').then(function (data) {
    var allSeries = data.seriesDepthOne.series;
    var byCategory = categorizeSeries(allSeries, true);
    PageCache.set('series.byCategory.all', byCategory);
    return byCategory;
  });

  PageCache.await('series.latest').then(function (data) {
    // series.latest is already processed by another transform so it doesn't
    // contain any of the extras.
    var byCategory = categorizeSeries(data);
    PageCache.set('series.byCategory.latest', byCategory);
    return byCategory;
  });
});

